import { Component, OnInit } from '@angular/core';
import { Globals } from '../../../../globals';
import { MessagingService } from '../../../../services/messaging.service';
import {
  EVENT_IO_CHANGE_SIZE, EVENT_IO_CHANGE_VIEW, EVENT_IO_ORDER,
  EVENT_IO_SORT, EVENT_IO_UPLOAD_FILE, EVENT_IO_PUBLISH
} from '../../../../constants';
import { MatSelectChange } from '@angular/material/select';
import { IconRegistryService } from '../../../../utilities/icon-registry.service';

interface OrganizerOptions {
  isAscending: boolean;
  sortBy: enumSortBy;
  viewMode: enumIOViewMode;
}

export enum enumIOViewMode {
  Thumbnail = "Thumbnail",
  ThumbnailWithZoom = "Thumbnail w/ Zoom",
  Pane = "Pane",
  Gallery = "Gallery",
  Detail = "Detail",
  DetailWithThumbnail = "Detail w/ Thumbnail"
}

export enum enumSortBy {
  DateCreated = "Date Created",
  DateModified = "Date Modified",
  ToothCase = "Tooth/Case",
  PatientName = "Patient Name",
  TagCategory = "Tag/Category",
  UserDefined = "User Defined"
}

@Component({
  selector: 'app-io-toolbar',
  templateUrl: './io-toolbar.component.html',
  styleUrls: ['./io-toolbar.component.css']
})
export class IoToolbarComponent implements OnInit {
  public options: OrganizerOptions = {
    isAscending: false,
    sortBy: enumSortBy.DateCreated,
    viewMode: enumIOViewMode.Thumbnail
  };

  public enumIOViewMode = enumIOViewMode;
  public enumSortBy = enumSortBy;
  public selectedSize: number = 150;

  public sizeOptions: any[] = [
    { name: "64 x 64", value: 64 },
    { name: "80 x 80", value: 80 },
    { name: "96 x 96", value: 96 },
    { name: "128 x 128", value: 128 },
    { name: "150 x 150", value: 150 },
    { name: "175 x 175", value: 175 },
    { name: "200 x 200", value: 200 },
    { name: "250 x 250", value: 250 },
    { name: "400 x 400", value: 400 }
  ];


  // TODO: uncomment these to show them on the UI 
  public viewOptions: enumIOViewMode[] = [
    enumIOViewMode.Detail,
    // enumIOViewMode.DetailWithThumbnail,
    enumIOViewMode.Gallery,
    enumIOViewMode.Pane,
    enumIOViewMode.Thumbnail,
    // enumIOViewMode.ThumbnailWithZoom,
  ];

  public sortOptions: enumSortBy[] = [
    enumSortBy.DateCreated,
    enumSortBy.DateModified,
    // enumSortBy.PatientName,
    // enumSortBy.TagCategory,
    // enumSortBy.ToothCase,
    // enumSortBy.UserDefined
  ];

  constructor(public globals: Globals, private _messagingService: MessagingService, iconRegistry: IconRegistryService) {
    iconRegistry.registerIcon("external-link", "assets/icons/icons8-external-link.svg");
    iconRegistry.registerIcon("upload", "assets/icons/icons8-upload-to-the-cloud.svg");
    iconRegistry.registerIcon("filter", "assets/icons/icons8-filter.svg");
    iconRegistry.registerIcon("photo-gallery", "assets/icons/icons8-photo-gallery.svg");
    iconRegistry.registerIcon("send-email", "assets/icons/icons8-send-email.svg");
    iconRegistry.registerIcon("settings", "assets/icons/icons8-settings.svg");
  }

  ngOnInit() {}

  public onOrganizerClick(): void {
    console.log("Organizer clicked");
  }

  public onFileOpenClick(): void {
    this._messagingService.sendComponentMessage(EVENT_IO_UPLOAD_FILE, null);
  }

  public onPublishClick(): void {
    this._messagingService.sendComponentMessage(EVENT_IO_PUBLISH, null);
  }

  public onSizeSelected(event: MatSelectChange): void {
    this.selectedSize = event.value;
    this._messagingService.sendComponentMessage(EVENT_IO_CHANGE_SIZE, { size: event.value });
  }

  public onViewSelected(event: MatSelectChange): void {
    if (this.options.viewMode === event.value)
      return;

    this.options.viewMode = event.value;
    this._messagingService.sendComponentMessage(EVENT_IO_CHANGE_VIEW, { viewMode: event.value });
  }

  public onSortingSelected(event: MatSelectChange): void {
    if (this.options.sortBy === event.value)
      return;

    this.options.sortBy = event.value;
    this._messagingService.sendComponentMessage(EVENT_IO_SORT, { sortBy: event.value });
  }

  public onChangingOrder(): void {
    this.options.isAscending = !this.options.isAscending;
    this._messagingService.sendComponentMessage(EVENT_IO_ORDER, { isAscending: this.options.isAscending });
  }
}
